export const INITIAL_FILTERS_STATE = {
  startDateFrom: '',
  startDateTo: '',
  endDateFrom: '',
  endDateTo: '',
  onlyActive: false,
};

export const SPECIAL_OFFERS_PAGE_INFO = {
  title: 'Special Offers',
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  DEFAULT_PAGE_SIZE: 100,
};

export const SPECIAL_OFFERS_DATE_RANGES = [
  {
    title: 'Start Date Range',
    fields: [
      {
        type: 'date',
        label: 'From',
        name: 'startDateFrom',
        className: 'date',
      },
      {
        type: 'date',
        label: 'To',
        name: 'startDateTo',
        className: 'date',
      },
    ],
  },
  {
    title: 'End Date Range',
    fields: [
      {
        type: 'date',
        label: 'From',
        name: 'endDateFrom',
        className: 'date',
      },
      {
        type: 'date',
        label: 'To',
        name: 'endDateTo',
        className: 'date',
      },
    ],
  },
];

export const SPECIAL_OFFERS_FIELDS = [
  {
    type: 'checkbox',
    label: 'Show only active offers',
    name: 'onlyActive',
    className: 'basic',
  },
];
